/* eslint-disable */
export const HOLIDAYS = {
	"Adam": "12-24",
	"Adéla": "09-02",
	"Adolf": "06-17",
	"Adriana": "06-26",
	"Agáta": "10-14",
	"Alan": "08-14",
	"Albert": "11-21",
	"Albína": "12-16",
	"Alena": "08-13",
	"Aleš": "04-13",
	"Alexandr": "02-27",
	"Alexandra": "04-21",
	"Alexej": "05-03",
	"Alice": "01-15",
	"Alois": "06-21",
	"Alžběta": "11-19",
	"Amálie": "07-10",
	"Anastázie": "04-15",
	"Anděla": "03-11",
	"Andrea": "09-26",
	"Andrej": "10-11",
	"Aneta": "05-17",
	"Anežka": "03-02",
	"Anna": "07-26",
	"Antonie": "06-12",
	"Antonín": "06-13",
	"Apolena": "02-09",
	"Arnošt": "03-30",
	"Artur": "11-26",
	"Augustýn": "08-28",
	"Barbora": "12-04",
	"Bartoloměj": "08-24",
	"Beáta": "10-25",
	"Bedřich": "03-01",
	"Běla": "01-21",
	"Benedikt": "11-12",
	"Benjamín": "12-07",
	"Bernard": "08-20",
	"Berta": "09-23",
	"Blahoslav": "04-30",
	"Blanka": "12-02",
	"Blažej": "02-03",
	"Blažena": "05-10",
	"Bohdan": "11-09",
	"Bohdana": "01-11",
	"Bohumil": "10-03",
	"Bohumila": "12-28",
	"Bohumír": "11-08",
	"Bohuslav": "08-22",
	"Bohuslava": "07-07",
	"Boleslav": "09-06",
	"Bonifác": "05-14",
	"Bořek": "07-12",
	"Boris": "09-05",
	"Bořivoj": "07-30",
	"Božena": "02-11",
	"Břetislav": "01-10",
	"Brigita": "10-21",
	"Bronislav": "09-03",
	"Bruno": "06-11",
	"Cecílie": "11-22",
	"Čeněk": "07-19",
	"Čestmír": "01-08",
	"Ctibor": "05-09",
	"Ctirad": "01-16",
	"Cyril": "07-05",
	"Dagmar": "12-20",
	"Dalibor": "06-04",
	"Dalimil": "01-05",
	"Dana": "12-11",
	"Daniel": "12-17",
	"Daniela": "09-09",
	"Darina": "09-22",
	"Darja": "04-10",
	"David": "12-30",
	"Denisa": "09-11",
	"Diana": "01-04",
	"Dita": "03-27",
	"Dobromila": "02-05",
	"Dobroslav": "06-05",
	"Dominik": "08-04",
	"Dorota": "02-26",
	"Doubravka": "01-19",
	"Drahomíra": "07-18",
	"Drahoslav": "01-17",
	"Drahoslava": "07-09",
	"Dušan": "04-09",
	"Edita": "01-13",
	"Eduard": "03-18",
	"Elena": "03-16",
	"Eliška": "10-05",
	"Ema": "04-08",
	"Emanuel": "03-26",
	"Emil": "05-22",
	"Emílie": "11-24",
	"Erik": "10-26",
	"Erika": "04-02",
	"Ester": "12-19",
	"Eva": "12-24",
	"Evelína": "08-29",
	"Evžen": "11-10",
	"Evženie": "04-22",
	"Felix": "11-01",
	"Ferdinand": "05-30",
	"Filip": "05-26",
	"František": "10-04",
	"Františka": "03-09",
	"Gabriel": "03-24",
	"Gabriela": "03-08",
	"Gita": "06-10",
	"Gizela": "02-18",
	"Gustav": "08-02",
	"Hana": "08-15",
	"Hanuš": "10-06",
	"Havel": "10-16",
	"Hedvika": "10-17",
	"Helena": "08-18",
	"Herbert": "03-16",
	"Heřman": "04-07",
	"Hermína": "04-07",
	"Horymír": "02-29",
	"Hubert": "11-03",
	"Hugo": "04-01",
	"Hynek": "02-01",
	"Ida": "03-15",
	"Ignác": "07-31",
	"Igor": "10-01",
	"Ilja": "07-20",
	"Ilona": "01-20",
	"Ingrid": "01-27",
	"Irena": "04-16",
	"Irma": "09-10",
	"Iva": "12-01",
	"Ivan": "06-25",
	"Ivana": "04-04",
	"Iveta": "06-07",
	"Ivo": "05-19",
	"Ivona": "03-23",
	"Izabela": "04-11",
	"Jáchym": "08-16",
	"Jakub": "07-25",
	"Jan": "06-24",
	"Jana": "05-24",
	"Jarmil": "06-02",
	"Jarmila": "02-04",
	"Jaromír": "09-24",
	"Jaroslav": "04-27",
	"Jaroslava": "07-01",
	"Jeroným": "09-30",
	"Jindřich": "07-15",
	"Jindřiška": "09-04",
	"Jiří": "04-24",
	"Jiřina": "02-15",
	"Jitka": "12-05",
	"Johana": "08-21",
	"Jolana": "09-15",
	"Jonáš": "09-27",
	"Josef": "03-19",
	"Judita": "12-29",
	"Julie": "12-10",
	"Julius": "04-12",
	"Justýna": "10-07",
	"Kamil": "03-03",
	"Kamila": "05-31",
	"Karel": "11-04",
	"Karina": "01-02",
	"Karolína": "07-14",
	"Kateřina": "11-25",
	"Kazimír": "03-05",
	"Klára": "08-12",
	"Klaudie": "05-05",
	"Klement": "11-23",
	"Kristián": "08-05",
	"Kristýna": "07-24",
	"Kryštof": "09-18",
	"Květa": "06-20",
	"Květoslav": "05-04",
	"Květoslava": "12-08",
	"Kvido": "03-31",
	"Lada": "08-07",
	"Ladislav": "06-27",
	"Laura": "06-01",
	"Lenka": "02-21",
	"Leona": "03-22",
	"Leopold": "11-15",
	"Leoš": "06-19",
	"Liběna": "11-06",
	"Libor": "07-23",
	"Libuše": "07-10",
	"Liliana": "02-25",
	"Linda": "09-01",
	"Ljuba": "02-16",
	"Lubomír": "06-28",
	"Lubor": "09-13",
	"Luboš": "07-16",
	"Lucie": "12-13",
	"Luděk": "08-26",
	"Ludmila": "09-16",
	"Ludvík": "08-19",
	"Lukáš": "10-18",
	"Lumír": "02-28",
	"Lýdie": "12-14",
	"Magdaléna": "07-22",
	"Mahulena": "11-16",
	"Marcel": "10-12",
	"Marcela": "04-20",
	"Marek": "04-25",
	"Marián": "03-25",
	"Mariana": "09-08",
	"Marie": "09-12",
	"Marika": "01-31",
	"Marina": "10-10",
	"Markéta": "07-13",
	"Marta": "07-29",
	"Martin": "11-11",
	"Martina": "07-17",
	"Matěj": "02-24",
	"Matouš": "09-21",
	"Matylda": "03-14",
	"Maxmilián": "05-29",
	"Medard": "06-08",
	"Michaela": "10-19",
	"Michal": "09-29",
	"Mikuláš": "12-06",
	"Milada": "02-08",
	"Milan": "06-18",
	"Milena": "01-24",
	"Miloš": "01-25",
	"Miloslav": "12-18",
	"Miloslava": "02-17",
	"Miluše": "08-03",
	"Miriam": "11-05",
	"Miroslav": "03-06",
	"Miroslava": "04-05",
	"Mojmír": "02-10",
	"Monika": "05-21",
	"Naděžda": "09-17",
	"Natálie": "12-21",
	"Nataša": "05-18",
	"Nela": "02-02",
	"Nikola": "11-20",
	"Nina": "10-24",
	"Nora": "07-08",
	"Norbert": "06-06",
	"Oldřich": "02-20",
	"Oldřiška": "08-06",
	"Oleg": "09-20",
	"Olga": "07-11",
	"Oliver": "10-02",
	"Olívie": "10-02",
	"Ondřej": "11-30",
	"Oskar": "08-01",
	"Otakar": "08-27",
	"Otmar": "11-16",
	"Oto": "04-26",
	"Otýlie": "01-28",
	"Pankrác": "05-12",
	"Patricie": "07-02",
	"Patrik": "02-19",
	"Pavel": "06-29",
	"Pavla": "06-22",
	"Pavlína": "08-31",
	"Petr": "02-22",
	"Petra": "08-17",
	"Pravoslav": "01-12",
	"Přemysl": "05-16",
	"Prokop": "07-04",
	"Radana": "12-15",
	"Radek": "03-21",
	"Radim": "08-25",
	"Radka": "09-14",
	"Radmila": "01-03",
	"Radomír": "07-03",
	"Radoslav": "05-06",
	"Radovan": "01-14",
	"Regína": "09-07",
	"Řehoř": "03-12",
	"Renáta": "10-13",
	"René": "11-28",
	"Richard": "04-03",
	"Robert": "04-29",
	"Robin": "01-30",
	"Roland": "06-14",
	"Roman": "08-09",
	"Romana": "11-18",
	"Rostislav": "04-19",
	"Rudolf": "04-17",
	"Rút": "03-14",
	"Růžena": "03-13",
	"Sabina": "10-22",
	"Samuel": "09-01",
	"Sandra": "08-23",
	"Sára": "10-09",
	"Šárka": "06-30",
	"Šarlota": "10-27",
	"Saskie": "11-07",
	"Sáva": "11-14",
	"Servác": "05-13",
	"Silvestr": "12-31",
	"Silvie": "10-29",
	"Šimon": "12-22",
	"Simona": "12-12",
	"Slavěna": "02-12",
	"Slavoj": "06-07",
	"Slavomír": "01-22",
	"Soběslav": "08-08",
	"Soňa": "03-28",
	"Stanislav": "05-07",
	"Stanislava": "06-09",
	"Štefan": "10-09",
	"Stela": "03-04",
	"Štěpán": "12-26",
	"Štěpánka": "10-31",
	"Svatava": "05-11",
	"Svatopluk": "02-23",
	"Svatoslav": "12-03",
	"Světlana": "03-20",
	"Tadeáš": "10-30",
	"Tamara": "06-03",
	"Taťána": "03-29",
	"Teodor": "10-23",
	"Tereza": "10-15",
	"Tibor": "11-13",
	"Tobiáš": "11-02",
	"Tomáš": "03-07",
	"Václav": "09-28",
	"Valdemar": "05-27",
	"Valentýn": "02-14",
	"Valérie": "04-18",
	"Vanda": "02-06",
	"Vavřinec": "08-10",
	"Věnceslav": "02-13",
	"Vendelín": "10-20",
	"Vendula": "04-06",
	"Věra": "10-08",
	"Veronika": "02-07",
	"Věroslav": "07-27",
	"Viktor": "07-28",
	"Viktorie": "03-10",
	"Vilém": "05-28",
	"Vilma": "01-07",
	"Vincenc": "04-14",
	"Viola": "05-25",
	"Vít": "06-15",
	"Vítězslav": "07-21",
	"Vladan": "01-09",
	"Vladěna": "08-30",
	"Vladimír": "05-23",
	"Vladislav": "01-18",
	"Vlasta": "12-23",
	"Vlastimil": "03-17",
	"Vlastislav": "04-28",
	"Vojtěch": "04-23",
	"Vratislav": "12-09",
	"Xenie": "11-27",
	"Žaneta": "12-27",
	"Zbyněk": "06-16",
	"Zbyšek": "05-20",
	"Zdeněk": "01-23",
	"Zdena": "06-23",
	"Zdislava": "01-29",
	"Zikmund": "05-02",
	"Zina": "11-29",
	"Zita": "09-19",
	"Zlata": "09-25",
	"Zoe": "10-27",
	"Žofie": "05-15",
	"Zora": "01-26",
	"Zuzana": "08-11"
};
